import React from 'react'
import './css/WorkTogether.css'
import IconImage from '../../assets/Vector.png'
export default function WorkTogether() {
    return (
        <section className="WorkTogether-section" >
            <div className="customcontainer">

                <div className='work-wrapper'>
                    <div className="work-left" data-aos="fade-up">
                        <h2 data-aos="fade-up">
                            We Work Together & <br />
                            Never Give Up
                        </h2>

                        <p data-aos="fade-up">
                            Driven by compassion and collective effort, we stand beside those in need, believing that true change begins when people come together with empathy and purpose. Every act of kindness, every helping hand, and every shared commitment strengthens lives, restores dignity, and nurtures hope—bringing us closer to meaningful and lasting change for individuals, families, and communities.</p>
                    </div>
                    <div className="work-right">
                        {/* <div className="stat-box red" data-aos="fade-up">
                            <h3>250+</h3>
                            <span>Total Happy Children</span>
                        </div>

                        <div className="stat-box yellow" data-aos="fade-up">
                            <h3>250+</h3>
                            <span>Total Our Volunteer</span>
                        </div>

                        <div className="stat-box green" data-aos="fade-up">
                            <h3>250+</h3>
                            <span>Our Products & Gifts</span>
                        </div>

                        <div className="stat-box blue" data-aos="fade-up">
                            <h3>250+</h3>
                            <span>Worldwide Donor</span>
                        </div> */}


                        <div className="stat-box yellow" data-aos="fade-up">
                            <h3>50+</h3>
                            <span>HIV+ Children Cared For</span>
                        </div>

                        <div className="stat-box green" data-aos="fade-up">
                            <h3>100+</h3>
                            <span>Children Supported in Education</span>
                        </div>

                        <div className="stat-box blue" data-aos="fade-up">
                            <h3>50+</h3>
                            <span>Gau Seva</span>
                        </div>
                        <div className="stat-box red" data-aos="fade-up">
                            <h3>5+</h3>
                            <span>Cancer Patients Supported</span>
                        </div>
                    </div>
                </div>
               

            </div>

        </section>
    )
}
